// frontend/src/components/blog/BlogImage.js
//
// Responsive blog cover image. Serves lightweight WebP variants via a <picture>
// srcset (generated at build time by scripts/optimize-images.js) and falls back
// to the committed PNG for the rare browser without WebP support. The PNG also
// stays the OG / JSON-LD image, so it is never removed.
//
// `sizes` should describe the rendered width at each breakpoint so the browser
// picks the smallest sufficient variant (default assumes full container width).

import React from "react";
import { Box } from "@mui/material";

// Keep in sync with WIDTHS in scripts/optimize-images.js.
const WIDTHS = [480, 768, 1200];

const BlogImage = ({ src, alt, sizes = "100vw", loading = "lazy", imgSx }) => {
  if (!src) return null;

  const isPng = /\.png$/i.test(src);
  const base = src.replace(/\.png$/i, "");
  const webpSrcSet = isPng
    ? WIDTHS.map((w) => `${base}-${w}.webp ${w}w`).join(", ")
    : undefined;

  return (
    <Box component="picture" sx={{ display: "block", width: "100%", height: "100%" }}>
      {webpSrcSet && (
        <source type="image/webp" srcSet={webpSrcSet} sizes={sizes} />
      )}
      <Box
        component="img"
        src={src}
        alt={alt}
        loading={loading}
        sx={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          display: "block",
          ...imgSx,
        }}
      />
    </Box>
  );
};

export default BlogImage;
